/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import '@ciscospark/internal-plugin-wdm';
import '@ciscospark/internal-plugin-encryption';
import '@ciscospark/internal-plugin-conversation';

import {registerInternalPlugin} from '@ciscospark/spark-core';
import Calendar from './calendar';
import config from './config';
import {has} from 'lodash';

registerInternalPlugin('calendar', Calendar, {
  config,
  payloadTransformer: {
    predicates: [
      {
        name: 'transformMeetingArray',
        direction: 'inbound',
        test(ctx, response) {
          return Promise.resolve(has(response, 'body.items[0].seriesId'));
        },
        extract(response) {
          return Promise.resolve(response.body.items);
        }
      },
      {
        name: 'transformMeeting',
        direction: 'inbound',
        test(ctx, response) {
          return Promise.resolve(has(response, 'body.seriesId'));
        },
        extract(response) {
          return Promise.resolve(response.body);
        }
      },
      {
        name: 'transformMeeting',
        direction: 'inbound',
        test(ctx, response) {
          return Promise.resolve(has(response, 'calendarMeetingExternal'));
        },
        extract(response) {
          return Promise.resolve(response.calendarMeetingExternal);
        }
      }
    ],
    transforms: [
      {
        name: 'transformMeetingArray',
        fn(ctx, array) {
          return Promise.all(array.map((item) => ctx.transform('transformMeeting', item)));
        }
      },
      {
        name: 'transformMeeting',
        direction: 'inbound',
        fn(ctx, object) {
          if (!object) {
            return Promise.resolve();
          }

          if (!object.encryptionKeyUrl) {
            return Promise.resolve();
          }

          // Decrypt participant properties
          const decryptedParticipants = object.encryptedParticipants.map((participant) => Promise.all([
            ctx.transform('decryptTextProp', 'encryptedEmailAddress', object.encryptionKeyUrl, participant),
            ctx.transform('decryptTextProp', 'encryptedName', object.encryptionKeyUrl, participant)
          ]));

          return Promise.all([
            ctx.transform('decryptTextProp', 'encryptedSubject', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'encryptedLocation', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'encryptedNotes', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'webexURI', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'webexURL', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'spaceMeetURL', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'spaceURI', object.encryptionKeyUrl, object),
            ctx.transform('decryptTextProp', 'spaceURL', object.encryptionKeyUrl, object)
          ].concat(decryptedParticipants));
        }
      }
    ]
  }
});

export {default} from './calendar';
